import React, { useState, useEffect, useRef } from 'react';
import { Wrapper } from './style';
import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import Icon from "react-multi-date-picker/components/icon";
import DateObject from "react-date-object";
import gregorian from 'react-date-object/calendars/gregorian';
import gregorian_en from "react-date-object/locales/gregorian_en";

// Libs
import Translation from 'libs/Translation'
import { APP_CONSTANTS } from 'constants';

const JalaliDatePicker = ({ label, val, handleChange }) => {
	let defaultDate = ['', '', ''];
	if (val) {
		defaultDate = Translation.dateWithoutTime(`${val}Z`).split(' ');
	}
	const [year, setYear] = useState(Translation.toEnNum(defaultDate[2]) || 1300);
	const [month, setMonth] = useState(defaultDate[1] || 'فروردین');
	const [monthNum, setMonthNum] = useState(APP_CONSTANTS?.JALALI_MONTH.find(m => m.name === defaultDate[1])?.num || `01`);
	const [day, setDay] = useState(Translation.toEnNum(defaultDate[0]) || `01`);
	const [date, setDate] = useState();
	const [active, setActive] = useState(false);
	const dayPickerRef = useRef();
	const monthPickerRef = useRef();
	const yearPickerRef = useRef();

	const handleChangeYear = (date) => {
		setYear(date?.year);
	}
	const handleChangeMonth = (date) => {
		setMonth(date?.month?.name);
		setMonthNum(date?.month?.number);
	}
	const handleChangeDay = (date) => {
		setDay(date?.day);
	}

	// Convert jalali to UTC
	useEffect(() => {	
		let _date = new DateObject({calendar:persian, date: `${year}/${monthNum}/${day}`});
		_date.convert(gregorian, gregorian_en);
		_date = _date.format();
		_date = _date.replaceAll('/', '-');
		const UTCTime = `${_date}T00:00:00.000Z`;
		setDate(UTCTime);
		handleChange(UTCTime)
	}, [year, month, day])

	return (
		<Wrapper active={active}>
			<span className='label'>
				{label}
			</span>
			<div className='birth-date'>
				<div className='column-flex'>
					<span className='label'>
						روز
					</span>	
					<div 
						className='row-flex first-input'
						onClick={() => active !== '1' && dayPickerRef.current.openCalendar()}
					>
						<DatePicker 
							hideYear
							hideMonth
							hideWeekDays
  							onlyDayPicker 
							ref={dayPickerRef} 
							highlightToday={false}
							weekStartDayIndex={5} 
							editable={false}
							onOpen={() => setActive('1')}
							onClose={() => setActive(false)}
							render={<Icon style={{width: '25px', height: '25px', color: '#B2B1B3'}}/>}
  							calendar={persian}
  							locale={persian_fa}
							onChange={handleChangeDay}
  							calendarPosition="bottom-right"
							style={{width: '140px', height: '38px'}}
						/>
						<span className='value'>
							{Translation.n(day)}
						</span>
					</div>
					
				</div>
				<div className='column-flex'>
					<span className='label'>
						ماه
					</span>	
					<div 
						className='row-flex second-input'
						onClick={() => active !== '2' && monthPickerRef.current.openCalendar()}
					>
						<DatePicker 
							hideYear
  							onlyMonthPicker 
							editable={false}
							ref={monthPickerRef} 
							onOpen={() => setActive('2')}
							onClose={() => setActive(false)}
							render={<Icon style={{width: '25px', height: '25px', color: '#B2B1B3'}}/>}
  							calendar={persian}
  							locale={persian_fa}
							onChange={handleChangeMonth}
  							calendarPosition="bottom-right"
							style={{width: '140px',  height: '38px'}}
						/>
						<span className='value'>
							{month}
						</span>
					</div>
				</div>
				<div className='column-flex'>
					<span className='label'>
						سال
					</span>	
					<div 
						className='row-flex third-input'
						onClick={() => active !== '3' && yearPickerRef.current.openCalendar()}
					>
						<DatePicker 
							hideMonth
  							onlyYearPicker 
							editable={false}
  							calendar={persian}
							ref={yearPickerRef} 
  							locale={persian_fa}
							onOpen={() => setActive('3')}
							onClose={() => setActive(false)}
							render={<Icon style={{width: '25px', height: '25px', color: '#B2B1B3'}}/>}
							onChange={handleChangeYear}
  							calendarPosition="bottom-left"
							style={{width: '140px',  height: '38px'}}
						/>
						<span className='value'>
							{Translation.n(year)}
						</span>
					</div>
					
				</div>
			</div>
		</Wrapper>
	);
};

export default JalaliDatePicker;